//import React, {Component} from 'react';
import React from 'react';
import PropTypes from 'prop-types';
//import { withStyles } from '@material-ui/core/styles';
import {withStyles} from "@material-ui/core";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
//import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import SecurityIcon from '@material-ui/icons/Security';
//import Icon from '@material-ui/core/Icon';
//import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
//import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@material-ui/core/Tooltip';
import Popover from '@material-ui/core/Popover';
import NavigationIcon from '@material-ui/icons/Navigation';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Grid from "@material-ui/core/Grid";
import GridList from '@material-ui/core/GridList';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';


 /* const styles = {


};*/

const styles = theme => ({
    margin: {
        margin: theme.spacing.unit * 2,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit * 8,
    },
    card: {
        maxWidth: 600,
        backgroundColor:'#e9eef2',
        borderWidth:2,
        borderColor:'black',
        marginBottom:'10px'
    },

});


//'url(' + require('../../images/IMG_1.JPG')
class CardPoliceInformation extends React.Component {

            constructor(props) {
                super(props);
                this.state = {
                    age: '',
                    name: 'Farshid',
                    testnumber: '1232322',
                    labelWidth: 0,
                    open:false,
                };
                //const unsubscribe = store.subscribe( () => {/*console.log(store.getState())*/});
                this.deleteImageClick = this.deleteImageClick.bind(this);
                this.editImageClick = this.editImageClick.bind(this);
                this.handleClickOpen = this.handleClickOpen.bind(this);
                this.handleClose = this.handleClose.bind(this);
                this.PaperComponent = this.PaperComponent.bind(this);
                this.handleDelete = this.handleDelete.bind(this);

            }


    deleteImageClick(argData){

        //alert('delete was 1 called');
        // this.props.onDelete(argData.id);
        this.setState({ open: true });


    }

    

    editImageClick(argData){
        //alert('edit was  1 called');
        /*const { data} = this.props;
        data.forEach((item)=>{item.editMode = false});
        if(argData.editMode){
            if(argData.editMode == true) {

                argData.editMode = false;
            }else{
                argData.editMode = true;
            }
        }else{
            argData.editMode = true;
        }
        */

        this.props.onEdit(argData);
    }

    handleClickOpen(){
        this.setState({ open: true });
    };

    handleClose(){
        this.setState({ open: false });
    };

    handleDelete(){
        this.props.onDelete(this.props.info.id);
        this.setState({ open: false });
    };

    PaperComponent(props) {
        return (
            <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
    }


            render() {
            const {classes} = this.props;
               // const classes2 = useStyles();

            return (
                <div>
                < Card className = {classes.card}  elevation={3} raised={true}>
                    < CardActionArea >
                        < CardContent >
                            <Grid container spacing={24}>

                                    <Grid item xs={2} sm={2}>
                                    <SecurityIcon fontSize="large" color="primary"></SecurityIcon>

                                </Grid>
                                <Grid item xs={10} sm={10}>
                                      <div>
                                            < Typography  style={{display: 'inline-block'}}
                                                variant = "h6" >
                                                    Police Information - {this.props.info.departmentname}
                                            < /Typography>
                                        </div>
                                </Grid>
                            {/*
                                <Grid item xs={2} sm={2}>
                                    < Typography  style={{display: 'inline-block'}}
                                variant = "h6"
                                component = "h6" >
                                    Number: {` `}
                                    < /Typography>
                                </Grid>


                                <Grid item xs={3} sm={3}>
                                < Typography  style={{display: 'inline-block'}}
                                variant = "h6"
                                component = "h6" >
                                    {this.props.info.number}
                                    < /Typography>
                                </Grid>
                                */}
                                <Grid item xs={6} sm={6}>
                                        < Typography   style={{display: 'inline-block' , textDecoration: 'underline'}}
                                            variant = "subtitle2"
                                        >

                                        Chief Name:
                                < /Typography>
                                        <br/>
                                    < Typography  style={{display: 'inline-block',fontWeight:'fontWeightBold' , marginLeft: 15}}
                                        variant="subtitle1"
                                        >
                                        {this.props.info.chiefname}
                                        < /Typography>
                                        </Grid>


                            <Grid item xs={6} sm={6}>
                                    < Typography  style={{display: 'inline-block'}}
                                variant = "subtitle2"
                                 >
                                    Department Name:
                            < /Typography>
                                    <br/>
                                < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                                variant = "subtitle1"
                                 >
                                    {this.props.info.departmentname}
                                < /Typography>
                            </Grid>

                            <Grid item xs={6} sm={6}>
                                    < Typography  style={{display: 'inline-block'}}
                                        variant = "subtitle2" >
                                    Address:
                                    < /Typography>
                                    <br/>
                                < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                                    variant = "subtitle1" >
                                    {this.props.info.address1}  {this.props.info.address2}
                                < /Typography>
                            </Grid>


                                    <Grid item xs={6} sm={6}>
                    < Typography  style={{display: 'inline-block'}}
                variant = "subtitle2" >
                    City:
            < /Typography>
                <br/>
                < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                variant = "subtitle1" >
                    {this.props.info.city}
                    < /Typography>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        < Typography  style={{display: 'inline-block'}}
                                variant = "subtitle2" >
                        State:
                        < /Typography>
                                <br/>
                         < Typography  style={{display: 'inline-block', marginLeft: 15}}
                            variant = "subtitle1" >
                        {this.props.info.state}
                        < /Typography>
                    </Grid>
                            <Grid item xs={6} sm={6}>
                    < Typography  style={{display: 'inline-block'}}
                variant = "button" >
                    Country:
            < /Typography>
                <br/>
                < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                variant = "body1" >
                    {this.props.info.country}
                    < /Typography>
                    </Grid>

                    <Grid item xs={6} sm={6}>
                    < Typography  style={{display: 'inline-block'}}
                variant = "button" >
                    zipcode:
            < /Typography>
                <br/>
                < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                variant = "body1" >
                    {this.props.info.zipcode}
                    < /Typography>
                    </Grid>
                            <Grid item xs={6} sm={6}>
                                < Typography  style={{display: 'inline-block'}}
                                variant = "button" >
                                        Phone:
                                < /Typography>
                                    <br/>
                                    < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                                    variant = "body1" >
                                        {this.props.info.phone}
                                < /Typography>
                                </Grid>

                    <Grid item xs={6} sm={6}>
                        < Typography  style={{display: 'inline-block'}}
                            variant = "button" >
                            Email:
                        < /Typography>
                        <br/>
                        < Typography  style={{display: 'inline-block', marginLeft: 15 }}
                        variant = "body1" >
                            {this.props.info.email}
                        < /Typography>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                    < Typography  style={{display: 'inline-block'}}
                variant = "button" >
                    Web Address:
            < /Typography>
                <br/>
                < Typography  style={{display: 'inline-block', marginLeft: 15 }}
                variant = "body1" >
                    {this.props.info.webpagelink}
                    < /Typography>
                    </Grid>



                    <Grid item xs={6} sm={6}>
                    < Typography  style={{display: 'inline-block'}}
                variant = "button" >
                    Fax:
                    < /Typography>
                <br/>
                < Typography  style={{display: 'inline-block', marginLeft: 15 }}
                variant = "body1" >
                    {this.props.info.fax}
                    < /Typography>
                    </Grid>

                    <Grid item xs={6} sm={6}>
                    < Typography  style={{display: 'inline-block'}}
                variant = "button" >
                    Type:
            < /Typography>
                <br/>
                < Typography  style={{display: 'inline-block', marginLeft: 15 }}
                variant = "body1" >
                    {this.props.info.type}
                    < /Typography>
                    </Grid>

                    <Grid item xs={6} sm={6}>
                    < Typography  style={{display: 'inline-block'}}
                variant = "button" >
                    Logo:
            < /Typography>
                <br/>
                < Typography  style={{display: 'inline-block', marginLeft: 15 }}
                variant = "body1" >
                    {this.props.info.companylogolink}
                    < /Typography>
                    </Grid>

                    <Grid item xs={6} sm={6}>
                    < Typography  style={{display: 'inline-block'}}
                variant = "button" >
                    Time Zone:
            < /Typography>
                <br/>
                < Typography  style={{display: 'inline-block', marginLeft: 15 }}
                variant = "body1" >
                    {this.props.info.timezone}
                    < /Typography>
                    </Grid>


                    </Grid>
                        < /CardContent>
                < /CardActionArea>
            < CardActions >
                <Tooltip title="Delete" aria-label="Delete">
                    <IconButton color="secondary" aria-label="delete" className={classes.extendedIcon}>
                    <DeleteIcon fontSize="large" onClick={() =>this.deleteImageClick(this.props.info)}/>
                    </IconButton>

                    </Tooltip>
                    <Tooltip title="Edit" aria-label="Edit">
                    <IconButton  color="primary" aria-label="edit" className={classes.margin}>
                    <EditIcon fontSize="large" onClick={() =>this.editImageClick(this.props.info)}/>
                    </IconButton>
                    </Tooltip>

                    {/*
                    <Tooltip title="Add" aria-label="add">
                    <Fab color="primary" aria-label="add" className={ classes.margin}>
                    <AddIcon />
                    </Fab>
                    </Tooltip>
                    <Fab color="primary" aria-label="edit" className={classes.fab}>
                    <EditIcon fontSize="large" />
                    </Fab>
                    <Fab color="secondary" aria-label="delete" className={classes.fab}>
                    <DeleteIcon  fontSize="large"/>

                    </Fab>
                    */}

            < /CardActions>
            < /Card>


                <Dialog
                open={this.state.open}
                onClose={this.handleClose}
                PaperComponent={this.PaperComponent}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                    >
                    <DialogTitle id="alert-dialog-title">{"Do you want to remove a user?"}</DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                    This User with the first name {this.props.info.firstName} and last name  {this.props.info.lastName} will be deleted from your profile.
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                    Cancel
                    </Button>
                    <Button onClick={this.handleDelete} color="primary" autoFocus>
                Delete
                </Button>
                </DialogActions>
                </Dialog>

                </div>
        )
            ;
        }//end of render
}//End of class

CardPoliceInformation.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CardPoliceInformation);
